import React, { memo, useRef, useState } from 'react';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import ImageV2 from 'components_v2/common/ImageV2';
import LeadLiveIcon from 'components_v2/common/LeadLiveIcon/LeadLiveIcon';
import StoryCardPopup from 'components_v2/common/StoryCardPopup';
import RelatedStoriesCardBottom from 'components_v2/mobile/RelatedStoriesCardBottom/RelatedStoriesCardBottom';
import IconWrapper from './IconWrapper';
import s from './NewStoryCard.scss';
import { IMAGE_URL } from '../../../constants';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';
import SocialSharingMobile from '../../../routes/articleshow_v2/components/mobile/SocialSharingMobile/SocialSharingMobile';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

function NewStoryCard(props) {
  const {
    title,
    msid,
    isLarge,
    wu,
    imagesize,
    imageUrl,
    // isWapView,
    sectionName,
    cs,
    shouldNotlazyloadImage,
    ga4Category,
    ga4Type,
    ga4Label,
    gaIndex,
    cardType,
    isBigHeading,
    isVideoActive,
    syn,
    criticRating,
    fromToiPrint,
    createdTime2,
    synStyle,
    target,
    createdTime,
    slikeId,
    hoveredSlikeId,
    setSlikePreviewId,
    hoveredSlikeIndex,
    usePosterImage,
    showIIcon,
    des,
    showPlayIconAlso,
    showPopup,
    isPhotostoryList,
    buttonText,
    headingImageSrc,
    birthdate,
    occupation,
    hobbies,
    topCatText,
    videoviews,
    isTrendingorNew,
    tagName,
    tagColor,
    tagBgColor,
    width = 375,
    buttonBgColor,
    buttonTextColor,
    buttonDisabled,
    isLeadVideo,
    hasVideo,
    enableRelatedStoriesSupport,
    relatedStories,
  } = props;
  let { cmstype, iconClass, videoTime, tn } = props;
  if (!cmstype && tn) {
    if (tn !== 'video' && hasVideo) {
      tn = 'video';
    }
    const TN_CMSTYPE_MAPPING = {
      photostory: 'PHOTOGALLERYSLIDESHOWSECTION',
      video: 'MEDIAVIDEO',
      liveblog: 'LIVEBLOG',
    };
    const TN_ICONCLASS_MAPPING = {
      photostory: 'photoIcon',
      video: 'videoshowIcon',
      // liveblog: 'liveIconWrapper',
    };
    cmstype = TN_CMSTYPE_MAPPING[tn] || '';
    if (!iconClass) {
      iconClass = TN_ICONCLASS_MAPPING[tn] || '';
    }
  }
  if (cs) {
    iconClass = 'toiPlusIcon' || iconClass;
    if (videoTime) {
      videoTime = '';
    }
  }
  const handleTouchStart = id => {
    //setSlikePreviewId(id, gaIndex);
    if (typeof setSlikePreviewId === 'function') {
      setSlikePreviewId(id, gaIndex);
    } else {
      console.log('setSlikePreviewId is not a function');
    }
  };
  const [showDes, setShowDes] = useState(false);
  const [showBannerPopup, setShowBannerPopup] = useState(false);
  const [bannerPopup, setBannerPopup] = useState(null);
  const popupRef = useRef(null);

  const ImageElement = ImageV2;
  const checkHtml = /(<([^>]+)>)/i;
  const htmlStatus = title ? checkHtml.test(title) : '';
  let resizemode;
  let iconClass2;
  let height;
  if (
    cardType !== 'card_10' &&
    (cmstype === 'PHOTOGALLERYSLIDESHOWSECTION' ||
      cmstype === 'MOVIEREVIEW' ||
      tn === 'movie reviews' ||
      tn === 'movie-review' ||
      usePosterImage)
  ) {
    resizemode = 75;
    height = 250;
  } else if (cardType === 'card_10') {
    iconClass2 = s.vsIcon;
  }

  if (isPhotostoryList) {
    height = 200;
  }
  // Card types that don't show images
  const inlineCard = ['card_11_1'].includes(cardType);

  const handleShowDesInCard = () => {
    setShowDes(!showDes);
  };

  // Triggers PopupOverlay exit animation via ref
  const handleClosePopup = () => {
    // eslint-disable-next-line no-unused-expressions
    popupRef.current?.close?.();
  };

  // Called by PopupOverlay after animation ends — cleans up state
  const handlePopupClose = () => {
    if (document?.querySelector) {
      document.querySelector('body').classList.remove('overflowhidden');
    }
    setShowBannerPopup(false);
  };

  const handleBannerClick = banner => {
    if (document?.querySelector) {
      document.querySelector('body').classList.add('overflowhidden');
    }
    setShowBannerPopup(true);
    setBannerPopup(banner);
  };
  const updateplayerConfig = { skipReco: true };

  const onError = e => {
    e.target.onerror = null;
    e.target.src = 'https://static.toiimg.com/photo/123379562.cms';
  };

  const renderContent = () => (
    <>
      {cardType !== 'card_11' &&
        cardType !== 'card_11_1' &&
        cardType !== 'card_12' && (
          <div className={`${s.imgWrap} global_img_wrap`}>
            <div className={`${s.storyImg} global_story_img`}>
              <ImageElement
                key={`${msid}_${gaIndex}`}
                width={width || '375'}
                msid={msid}
                placeHolderSrc={`${IMAGE_URL}123379562.cms`}
                alt=""
                lazyload={!shouldNotlazyloadImage}
                // offsetVertical={200}
                resizemode={resizemode}
                height={height}
                slikeId={slikeId}
                hoveredSlikeId={hoveredSlikeId}
                hoveredSlikeIndex={hoveredSlikeIndex}
                gaIndex={gaIndex}
                imgsize={imagesize}
                onError={onError}
                src={imageUrl}
              />
            </div>
            {videoviews && (
              <span className={s.viewIcon}>
                <i />
                {videoviews}
              </span>
            )}
            {tagName && (
              <span
                className={s.tagName}
                style={{
                  color: tagColor || '#fff',
                  background: tagBgColor || '#214782',
                }}
              >
                {tagName === 'Live' ? (
                  <div className={`${s.liveBlinkerWrap}`}>
                    <div className={`${s.liveBtn} ${s.red}`} />
                    Live
                  </div>
                ) : (
                  tagName
                )}
              </span>
            )}

            {isTrendingorNew === 'New' && (
              <span className={s.newPill}>New</span>
            )}

            {isTrendingorNew === 'Trending' && (
              <span className={s.trendingIcon}>
                <i />
              </span>
            )}

            {(iconClass || iconClass2) && (
              <span className={`${s[iconClass]} ${iconClass2}`}>
                <i />
                {videoTime && <span> {videoTime} </span>}
              </span>
            )}
            {showPlayIconAlso && (
              <span className={`${s.videoIcon}`}>
                <i />
              </span>
            )}
            {cmstype &&
              cmstype === 'LIVEBLOG' && (
                <span className={s.liveIconWrapper}>
                  <LeadLiveIcon text="Live" />
                </span>
              )}
            {criticRating && (
              <div
                className={`${s.ratingWrap} ${
                  cardType === 'card_2' || cardType === 'card_3' ? s.topPos : ''
                }`}
              >
                <div className={s.ratingPosition}>
                  <div className={s.ratings}>
                    <p className={s.ratingsGiven}>
                      {criticRating} <span className={s.starIcon} />
                    </p>
                    <p className={s.ratingsBy}>Critics</p>
                  </div>
                  {/* <div className={s.line} />
                  <div className={s.ratings}>
                    <p className={s.ratingsGiven}>
                      {criticRating} <span className={s.starIcon} />
                    </p>
                    <p className={s.ratingsBy}>Audience</p>
                  </div> */}
                </div>
              </div>
            )}

            {/* Shadow Tile */}
            {occupation && <span className={s.shadowTile}>{occupation}</span>}

            {showIIcon && (
              <span
                className={`${s[iconClass]} ${s.infoIcon}`}
                onClick={handleShowDesInCard}
              >
                i
              </span>
            )}

            {des && (
              <p
                className={`${s.infoTextOverlay} ${showDes ? s.show : ''}`}
                dangerouslySetInnerHTML={{ __html: des }}
              />
            )}
          </div>
        )}
      <div className={`${s.scContentWrap} bg_color`}>
        {createdTime2 && <p className={s.createdTime}>{createdTime2}</p>}
        {topCatText && <div className={s.topCatText}>{topCatText}</div>}
        {headingImageSrc && (
          <div className={s.headingImage}>
            <img src={headingImageSrc} alt={title} />
          </div>
        )}
        {isLeadVideo && <p className={s.createdTime}>Watch</p>}
        {htmlStatus ? (
          <div
            className={`${s.cardHeading} style_change`}
            dangerouslySetInnerHTML={{
              __html: (
                <>
                  <IconWrapper
                    iconClass={iconClass}
                    cardType={cardType}
                    videoTime={videoTime}
                    cmstype={cmstype}
                    inlineCard={inlineCard}
                  />{' '}
                  {title}
                </>
              ),
            }}
          />
        ) : (
          <div className={`${s.cardHeading} style_change`}>
            <IconWrapper
              iconClass={iconClass}
              cardType={cardType}
              videoTime={videoTime}
              cmstype={cmstype}
              inlineCard={inlineCard}
            />{' '}
            {title}
          </div>
        )}

        {birthdate && (
          <span className={s.calendarDate}>
            <i className={s.calendarIcon} /> {birthdate}
          </span>
        )}

        {syn && (
          <p className={s.cardText} style={synStyle}>
            {syn}
          </p>
        )}
        {hobbies && <span className={s.redText}>{hobbies}</span>}

        {sectionName && <div className={s.catText}>{sectionName}</div>}
        {buttonText && (
          <div
            className={`${s.buttonText} ${buttonDisabled ? s.disabled : ''}`}
            style={{ background: buttonBgColor, color: buttonTextColor }}
          >
            {buttonText}
          </div>
        )}
        {fromToiPrint && (
          <div className={s.fromToiWrap}>
            <span>From TOI Print Edition</span>
            <ErrorBoundary>
              <SocialSharingMobile
                title={title}
                textRequired={false}
                url={wu || ''}
                disableShortUrl
                linkeDin
                via="@timesofindia"
                topsticky
                defaultEmailView
                isTablet={false}
                hideSharingButtons
                hideSharingNative
                placeHolderStyles={{ minHeight: '24px' }}
                placeHolderLoaderClass="follow_us_loader"
                hideFollow
              />
            </ErrorBoundary>
          </div>
        )}
        {createdTime && <span className={s.createdTime}> {createdTime}</span>}
      </div>
    </>
  );

  const handleCardClick = e => {
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: `${ga4Type}`,
        category: ga4Category || 'story_click',
        story_no: `${gaIndex}`,
        msid,
        label: ga4Label,
      });
    }

    if (showPopup) {
      e.preventDefault();
      const data = {
        imageid: msid,
        slikeId,
        id: msid,
        resizemode,
        title,
        imagesize,
        des,
        syn,
        sectionName,
      };
      handleBannerClick(data);
      return false;
    }

    try {
      if (showIIcon || e.target.innerHTML === 'Share') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    } catch (error) {
      //
    }
    return true;
  };

  const cardClassName = `border_color ${s.storyCard} ${
    isLarge ? s.isLarge : ''
  } ${cardType ? s[cardType] : ''} ${isBigHeading ? s.bigHeading : ''} ${
    !wu && !showPopup ? s.noLink : ''
  } ${isVideoActive ? s.videoActive : ''}`;

  const isRelatedStoriesPresent =
    enableRelatedStoriesSupport &&
    Array.isArray(relatedStories) &&
    relatedStories.length > 1;
  const WrapperDiv = ({ children }) =>
    isRelatedStoriesPresent ? (
      <div className={s.relatedStoriesCardContainer}>{children}</div>
    ) : (
      <>{children}</>
    );
  return (
    <WrapperDiv>
      {/* Popup for banner cards */}
      {bannerPopup &&
        bannerPopup?.imageid && (
          <StoryCardPopup
            white
            show={showBannerPopup}
            bannerPopup={bannerPopup}
            popupRef={popupRef}
            onClose={handleClosePopup}
            onOverlayClose={handlePopupClose}
            updateplayerConfig={updateplayerConfig}
            isMobile
          />
        )}

      {/* Main card */}
      {wu ? (
        <Link
          // eslint-disable-next-line no-script-url
          to={wu || 'javascript:void(0)'}
          target={!target ? '_blank' : target}
          className={cardClassName}
          onTouchStart={() => handleTouchStart(slikeId)}
          onClick={handleCardClick}
        >
          {renderContent()}
        </Link>
      ) : (
        <div
          className={`normalStoryCard ${cardClassName}`}
          onTouchStart={() => handleTouchStart(slikeId)}
          onClick={handleCardClick}
        >
          {renderContent()}
        </div>
      )}
      {isRelatedStoriesPresent && (
        <RelatedStoriesCardBottom
          data={{ ...props }}
          // isCtnCpd={isCtnCpd}
          isLeadImageNews
        />
      )}
    </WrapperDiv>
  );
}
NewStoryCard.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  isLable: PropTypes.bool,
  isLarge: PropTypes.string,
  ga4Type: PropTypes.string,
  ga4Label: PropTypes.string,
  gaIndex: PropTypes.number,
  cardType: PropTypes.string,
  shouldNotlazyloadImage: PropTypes.bool,
  showPopup: PropTypes.bool,
  birthdate: PropTypes.string,
  occupation: PropTypes.string,
  hobbies: PropTypes.string,
};

NewStoryCard.defaultProps = {
  isLable: false,
  isLarge: '',
  ga4Type: '',
  ga4Label: '',
  gaIndex: '',
  cardType: '',
  shouldNotlazyloadImage: false,
  showPopup: false,
  birthdate: '',
  occupation: '',
  hobbies: '',
};

export default memo(NewStoryCard);
